import {
    TOPFEATURE_UPDATE_START,
    TOPFEATURE_UPDATE_SUCCESS,
    TOPFEATURE_UPDATE_ERROR
} from '../../../constants/index';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { updateHomePageCategoryStatusMutation as mutation, getAllHomePageCategorySettings as query } from '../../../lib/graphql';

const updateTopFeatureStatus = (id, isActive) => {
    return async (dispatch, getState, { client }) => {

        try {
            dispatch({
                type: TOPFEATURE_UPDATE_START
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    id,
                    isActive: Number(isActive)
                },
                refetchQueries: [{ query }]
            });

            if (data?.updateTopFeatureStatus?.status == 200) {
                dispatch({
                    type: TOPFEATURE_UPDATE_SUCCESS
                });
                showToaster({ messageId: 'updateTopFeatureStatus', requestContent: id, toasterType: 'success' });
            } else {
                dispatch({
                    type: TOPFEATURE_UPDATE_ERROR
                });
                showToaster({ messageId: 'errorMessage', requestContent: data?.updateTopFeatureStatus?.errorMessage, toasterType: 'error' });
            }
        } catch (err) {
            showToaster({ messageId: 'catchMessage', requestContent: err, toasterType: 'error' });
            dispatch({
                type: TOPFEATURE_UPDATE_ERROR
            });
        }

    }
};

export default updateTopFeatureStatus;